export default __webpack_public_path__ + "static/media/actividad-4.6d97fd0b.mp3";